/* eslint-disable jsx-a11y/alt-text */
import IBMLogo from "../../Attachments/Images/IBMLogo.png";
import ProfilePic from "../../Attachments/Images/ProfilePic.jpg";
import KempDo from "../../Attachments/Images/Lyfe Home/Kempdo.png";
import KemPer from "../../Attachments/Images/Lyfe Home/KemPer.png";
import Taqychan from "../../Attachments/Images/Lyfe Home/Taqychan.png";
import DPRRI from "../../Attachments/Images/Lyfe Home/DPRRI.png";

export const CarouselData = [
  {
    Logo: IBMLogo,
    LogoSize: "h-10 w-24",
    ProfileImg: ProfilePic,
    TextContained:
      '"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis maximus accumsan lacus, et porta mauris rhoncus tristique. Lorem ipsum dolor sit amet, consectetur adipiscing elit."',
  },
  {
    Logo: KempDo,
    LogoSize: "h-20 w-40",
    ProfileImg: ProfilePic,
    TextContained:
      '"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus sit amet hendrerit libero. Maecenas at mauris lacinia, congue tellus vitae, sagittis lectus."',
  },
  {
    Logo: KemPer,
    LogoSize: "h-20 w-28",
    ProfileImg: ProfilePic,
    TextContained:
      '"Aenean molestie purus vestibulum malesuada posuere. Vivamus egestas in ligula id consequat. Phasellus vel nulla congue, varius diam vestibulum, aliquet risus."',
  },
  {
    Logo: DPRRI,
    LogoSize: "h-24 w-44",
    ProfileImg: ProfilePic,
    TextContained:
      '"Aenean sit amet felis sem. Etiam commodo turpis ac semper rhoncus. Nulla et lorem nec lorem scelerisque iaculis. Ut malesuada luctus nibh, vel viverra eros consectetur nec."',
  },
  {
    Logo: Taqychan,
    LogoSize: "h-24 w-32",
    ProfileImg: ProfilePic,
    TextContained:
      '"Maecenas eget risus suscipit, tempor lorem vel, vestibulum magna. Proin fringilla a dolor quis tincidunt. Aliquam blandit faucibus turpis. Donec consectetur imperdiet neque id facilisis."',
  },
];

